module.exports = __webpack_public_path__ + "img/sun-haze.b14c7944.svg";